import { render, staticRenderFns } from "./RecuperoPassword.vue?vue&type=template&id=7be8b5e1&scoped=true&"
import script from "./RecuperoPassword.vue?vue&type=script&lang=ts&"
export * from "./RecuperoPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be8b5e1",
  null
  
)

export default component.exports